module.exports = __webpack_public_path__ + "img/2024_PerformanceMen.bf67b59e.jpg";